<template>
  <project-manager-layout :spinning="isLoading">
    <leader-project-layout :model="model">
      <template #underInfo>
        <div class="leader-project__common-progress" v-if="model.id">
          <progress-bar-generated
            :show-label="true"
            :show-percent="true"
            :completed="model.completedCount"
            :completed-overdue="model.completedOverdueCount"
            :incomplete-overdue="model.incompleteOverdueCount"
            :incomplete="model.incompleteCount"
          />
        </div>
      </template>
      <ProjectShowcaseForm
        :showcase="model.showcase"
        :public-showcase="model.publicShowcase"
        @update="onShowcaseFormUpdate"
      >
        <leader-showcase-agreement-form
          v-if="showAgreement"
          :showcase="model.showcase"
          @update="onShowcaseFormUpdate"
        />
      </ProjectShowcaseForm>
    </leader-project-layout>
  </project-manager-layout>
</template>

<script setup>
  import { computed, onMounted, reactive, ref } from 'vue';
  import { useRoute } from 'vue-router';
  import { useApi } from '@/api/use-api';
  import ProjectManagerLayout from '@/layouts/ProjectManagerLayout.vue';
  import LeaderProjectLayout from '@/views/leader/projects/components/LeaderProjectLayout.vue';
  import ProjectShowcaseForm from '@/components/projects/showcase/ProjectShowcaseForm.vue';
  import { SHOWCASE_STATUS_ID_DRAFT } from '@/api/models/ProjectShowcaseStatus';
  import LeaderShowcaseAgreementForm from './components/LeaderShowcaseAgreementForm.vue.vue';
  import ProgressBarGenerated from '@/components/projects/portfolio/components/ProgressBarGenerated.vue';

  const api = useApi();
  const route = useRoute();
  const model = reactive({
    id: null,
    number: '',
    name: '',
    projectType: '',
    requestId: null,
    status: null,
    projectStatusId: null,
    isMyProject: false,
    showcase: null,
    publicShowcase: null,
    completedCount: 0,
    completedOverdueCount: 0,
    incompleteOverdueCount: 0,
    incompleteCount: 0,
  });
  const isLoading = ref(true);

  const showAgreement = computed(() => {
    return model.showcase?.statusId !== SHOWCASE_STATUS_ID_DRAFT;
  });

  onMounted(async () => {
    await getModel();
    await getShowcase();
    await getPublicShowcase();
    isLoading.value = false;
  });

  const getModel = async () => {
    try {
      const response = await api.leaderPage.view(route.params.id);
      model.name = response.project.name;
      model.number = response.project.id;
      model.id = response.project.id;
      model.type = response.project.type;
      model.requestId = response.project.requestId;
      model.status = response.project.status;
      model.projectStatusId = response.project.projectStatusId;
      model.isMyProject = response.project.isMyProject;
      model.completedCount = response.project.completedCount;
      model.completedOverdueCount = response.project.completedOverdueCount;
      model.incompleteOverdueCount = response.project.incompleteOverdueCount;
      model.incompleteCount = response.project.incompleteCount;
    } catch (error) {
      console.error('error', error);
    }
  };

  const getShowcase = async () => {
    try {
      const response = await api.showcase.getDraft(route.params.id);
      model.showcase = response.showcase;
    } catch (error) {
      console.error('error', error);
    }
  };

  const getPublicShowcase = async () => {
    try {
      const response = await api.showcase.getPublic(route.params.id);
      model.publicShowcase = response.showcase;
    } catch (error) {
      console.log('error', error);
    }
  };

  const onShowcaseFormUpdate = async () => {
    await getShowcase();
    await getPublicShowcase();
  };
</script>

<style lang="scss" scoped>
  @use '@/assets/styles/_colors.scss' as *;

  * {
    margin: 0;
    padding: 0;
  }

  .ant-input {
    font-family: 'Nunito Sans', sans-serif;
    &[disabled] {
      color: $color-text-primary;
    }
  }

  .leader-project__common-progress {
    margin-top: 42px;
  }
</style>
